import React, { Link } from 'react-router-dom';
import './cards.scss';

const Main = () => {
  const images = [
    {
      src: "https://seculosengenharia.com.br/files/cards/santa-izabel-3.jpg",
      title: "Santa Izabel - Pa",
      buttonText: "Saiba Mais",
      link: ""
    },
    {
      src: "https://seculosengenharia.com.br/files/cards/ore-sorting.jpg",
      title: "Projeto Ore Sorting ",
      buttonText: "Saiba Mais",
      link: "/projetos/ore-sorting",
    },
    {
      src: "https://seculosengenharia.com.br/files/cards/pera.jpg",
      title: "Pera Ferroviária",
      buttonText: "Saiba Mais",
      link: "/projetos/pera-ferroviaria"
    },
    {
      src: "https://seculosengenharia.com.br/files/cards/sossego.jpg",
      title: "Mina do Sossego - Pa",
      buttonText: "Saiba Mais",
      link: "projetos/sossego-vale"
    },
    // {
    //   src: "https://images.pexels.com/photos/13673325/pexels-photo-13673325.jpeg",
    //   title: "Paisaje Montañoso",
    //   buttonText: "Saiba Mais"
    // }
  ];

  return (
    <div className='carousel-container'>
      <div className="container card">
      <h3 className='carousel-title'>Qualidade na execução <br/> de cada projeto</h3>
        <div className="cards">
          {images.map((image, index) => (
            <div key={index} className="item">
              <img src={image.src} alt={`Slide ${index}`} />
              <div className="card-content">
                <h2>{image.title}</h2>
                <button>
                  <Link to={image.link}>
                    {image.buttonText}
                  </Link>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Main;